export const PERSONALISED_CACHE_HEADER = "personalisedCache";
export const CUSTOMER_GUID_COOKIE_NAME = "asos-cgd26";
export const CUSTOMER_GUID_PARAM_NAME = "CustomerGuid";
